<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id ? actions : []"
    :form="form"
    :actionButtons="actionButtons"
    :onFetchData="onFetchData"
    :tableEvents="onTableEvents()"
    :title="$t('menu.newStoreOwner')"
    resource="store_owners"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/store_owners.js';
import { TAG_TYPE } from '@/constants';

@Component
export default class NewStoreOwners extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  actionButtons = ['show']

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'first_name_cont',
      'last_name_cont',
      'kind_eq',
      'phone_cont',
      'whatsapp_cont',
      'email_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'first_name',
      'last_name',
      'kind',
      'phone',
      'whatsapp',
      type === 'show' && 'email',
      {
        prop: 'agent_status',
        label: this.$t('storeOwner.agentStatus'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <el-tag type={TAG_TYPE[value]}>{this.$t(`agent.statuses.${value}`)}</el-tag>;
          }
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'first_name',
      'last_name',
      'kind',
      'phone',
      'whatsapp',
      'email',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'store_owners.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'store_owners.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/store_owners', { params: { ...this.$route.query, source_eq: "sign_up" } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/store_owners/${this.$route.params.id}`);
      return { data };
    }

    if (type === 'new') {
      return {};
    }
  }

  onTableEvents() {
    const defaultEvents = {};
    if (this.actionButtons.includes('show')) {
      defaultEvents['row-click'] =  ({ id }) => {
        // 用户准备进行复制文字操作不要发生跳转
        if (window.getSelection) {
          const oSelection = window.getSelection();
          if (oSelection.toString) {
            const selection = oSelection.toString();
            if (selection) {
              return;
            }
          }
        }
        this.$router.push({ name: 'new_store_owners.show', params: { id } })
      };
    }
    return defaultEvents
  }
}

export const route = [
  {
    path: '/new_store_owners',
    name: 'new_store_owners.index',
    component: NewStoreOwners,
    props: {
      type: 'index',
    },
    meta: {
      can: 'store_owners.read'
    }
  },
  {
    path: '/new_store_owners/:id',
    name: 'new_store_owners.show',
    component: NewStoreOwners,
    props: {
      type: 'show',
    },
    meta: {
      can: 'store_owners.read'
    }
  },
  {
    path: '/new_store_owners/:id/edit',
    name: 'new_store_owners.edit',
    component: NewStoreOwners,
    props: {
      type: 'edit'
    },
    meta: {
      can: 'store_owners.udpate'
    }
  }
]
</script>
